const videosData = [
  // {
  //   id: 1,
  //   title: "SPRAYGROUND | SPEC OPS OFF ROAD BACKPACK",
  //   url: "https://www.youtube.com/embed/C84rM7icr80",
  //   type: "reel"
  // },
  // {
  //   id: 2,
  //   title: "SPRAYGROUND KW| MINECRAFT ULTIMATE BACKPACK",
  //   url: "https://www.youtube.com/embed/vWhj2_PXhMs",
  //   type: "reel"
  // },
        {
    id: 3526,
    title: "NGen SY| Motion Graphics Reel",
    url: "https://www.youtube.com/embed/ouGYQ63YXy8",
    type: "reel"
  },
      {
    id: 356,
    title: "KAYFA EG| Motion Graphics Reel",
    url: "https://www.youtube.com/embed/sN-W7xej1RQ",
    type: "reel"
  },
    {
    id: 39,
    title: "SKY AGENCY SY| Informative Reel",
    url: "https://www.youtube.com/embed/zf76joi5ZoM",
    type: "reel"
  },
    {
    id: 40,
    title: "SKY AGENCY SY| Informative Reel",
    url: "https://www.youtube.com/embed/H2WNFqQzy94",
    type: "reel"
  },
      {
    id: 41,
    title: "SKY 4Q SY| Rebranding Motion Graphics reel",
    url: "https://www.youtube.com/embed/TIPo7UkfL9k",
    type: "reel"
  },
{
    id: 22,
    title: "DELUXE SY| VFX Product Video Editing",
    url: "https://www.youtube.com/embed/hSgcER6oCw8",
    type: "reel"
  },

  // {
  //   id: 4,
  //   title: "SPRAYGROUND | TOKYO BUBBLE BACKPACKA",
  //   url: "https://www.youtube.com/embed/K_h582zPUHo",
  //   type: "reel"
  // },
  //  {
  //   id: 5,
  //   title: "SPRAYGROUND | TROPICAL SHARK BACKPACK",
  //   url: "https://www.youtube.com/embed/b7B4fgNFjk0",
  //   type: "reel"
  // },

  // {
  //   id: 38,
  //   title: "FETTA DORO x ADEEB SY| Advertisement Reel",
  //   url: "https://www.youtube.com/embed/kPsb7gKgYKU",
  //   type: "reel"
  // },
{
    id: 6,
    title: "TG Group SY| Grand Opening Cinematic Promo",
    url: "https://www.youtube.com/embed/kwjWI4J5Phc",
    type: "wide"
  },
// {
//     id: 7,
//     title: "SPRAYGROUND | AI SHARKGLYPHS BACKPACK",
//     url: "https://www.youtube.com/embed/bcE3KdV16QE",
//     type: "reel"
//   },
  {
    id: 9,
    title: "VIDEO ADVICE US| Youtube Video Editing",
    url: "https://www.youtube.com/embed/mpoSJonG0NI",
    type: "wide"
  },
// {
//     id: 10,
//     title: "SPRAYGROUND | TRINITY DIAMOND BACKPACK",
//     url: "https://www.youtube.com/embed/xZolOwfVOSg",
//     type: "reel"
//   },
{
    id: 31,
    title: "DELUXE SY| VFX Product Video Editing",
    url: "https://www.youtube.com/embed/jYlNJQ7Ho6s",
    type: "reel"
  },
{
    id: 21,
    title: "SPUNTINI SY| Product Video Editing",
    url: "https://www.youtube.com/embed/omCCNMCQU9E",
    type: "reel"
  },

  {
    id: 13,
    title: "BARNI SY| Food Expo 2025 Booth Promo",
    url: "https://www.youtube.com/embed/ZrrJ9dOHvyw",
    type: "reel"
  },
  {
    id: 30,
    title: "SPEED OF LIGHT SY| Service Motion Reel",
    url: "https://www.youtube.com/embed/tmcuo2j794M",
    type: "reel"
  },
  {
    id: 11,
    title: "KATAKIT SY| Food Expo 2025 Booth Promo",
    url: "https://www.youtube.com/embed/olh9tlD0jbg",
    type: "wide"
  },
  {
    id: 12,
    title: "SEDI HISHAM SY| Food Expo 2025 Booth Promo",
    url: "https://www.youtube.com/embed/nD0dmr3QaQY",
    type: "wide"
  },

{
    id: 14,
    title: "SPUNTINI SY| Mix Snacks Motion Reel",
    url: "https://www.youtube.com/embed/xlrxkBeXB3g",
    type: "reel"
  },
{
    id: 15,
    title: "SPUNTINI SY| Mix Flavors Motion Reel",
    url: "https://www.youtube.com/embed/mpBY5jsCI5M",
    type: "reel"
  },
{
    id: 16,
    title: "SPUNTINI SY| Cheese Snacks Motion Reel",
    url: "https://www.youtube.com/embed/fAmhJSr7mFo",
    type: "reel"
  },
{
    id: 17,
    title: "SPUNTINI SY| New product Motion Reel",
    url: "https://www.youtube.com/embed/WodKRvf4X2s",
    type: "reel"
  },
{
    id: 18,
    title: "SPUNTINI SY| New product Motion Reel",
    url: "https://www.youtube.com/embed/DD5hKrv8GdQ",
    type: "reel"
  },
{
    id: 19,
    title: "SPUNTINI SY| New product Motion Reel",
    url: "https://www.youtube.com/embed/o6PENGs7sYU",
    type: "reel"
  },
// {
//     id: 20,
//     title: "SPUNTINI SY| Food Expo Public Invitation",
//     url: "https://www.youtube.com/embed/6sYrU3ZwT6g",
//     type: "reel"
//   },
  {
    id: 8,
    title: "SPRAYGROUND KW| TEAR IT UP BACKPACK",
    url: "https://www.youtube.com/embed/kjo82pSMPpQ",
    type: "reel"
  },
    {
    id: 23,
    title: "DELUXE SY| Products Motion Reel",
    url: "https://www.youtube.com/embed/T9lc3JM9asY",
    type: "reel"
  },

      {
    id: 3,
    title: "SPRAYGROUND KW| CRAZEE DAZEES BACKPACK",
    url: "https://www.youtube.com/embed/7T7qboPpWkc",
    type: "reel"
  },
{
    id: 24,
    title: "DELUXE SY| Products Motion Reel",
    url: "https://www.youtube.com/embed/8DiB2QDnWKk",
    type: "reel"
  },

{
    id: 25,
    title: "MAKKI SY| Product Motion Reel",
    url: "https://www.youtube.com/embed/c9BWwPPfZj8",
    type: "reel"
  },
{
    id: 26,
    title: "MAKKI SY| Festival Booth Promo",
    url: "https://www.youtube.com/embed/rRCiwJc2EsU",
    type: "reel"
  },
{
    id: 27,
    title: "KOITA SY| Product Motion Reel",
    url: "https://www.youtube.com/embed/sHrbXwDCoN4",
    type: "reel"
  },
{
    id: 28,
    title: "PREMIUME FOODS X JARRITOS KW| Product Motion Reel",
    url: "https://www.youtube.com/embed/B4wmzKQgAwQ",
    type: "reel"
  },
{
    id: 29,
    title: "GROOM ME QA| Service Motion Reel",
    url: "https://www.youtube.com/embed/15bBs6z6DfE",
    type: "reel"
  },

{
    id: 32,
    title: "Pistachio World SY| Product Motion Reel",
    url: "https://www.youtube.com/embed/XYtoIzPG1tI",
    type: "reel"
  },
{
    id: 33,
    title: "Peanuts World SY| Product Motion Reel",
    url: "https://www.youtube.com/embed/B68-HNJ5GWI",
    type: "reel"
  },
{
    id: 34,
    title: "GO SMART KW| Product Motion Reel",
    url: "https://www.youtube.com/embed/RQnVIMgAmb0",
    type: "reel"
  },
{
    id: 35,
    title: "GO SMART KW| Script Video Editing",
    url: "https://www.youtube.com/embed/DegUub67IDQ",
    type: "reel"
  },
{
    id: 36,
    title: "GO SMART KW| Script Video Editing",
    url: "https://www.youtube.com/embed/yPY_mB2-e-s",
    type: "reel"
  },
{
    id: 37,
    title: "GO SMART KW| Script Video Editing",
    url: "https://www.youtube.com/embed/LzHJS3KPQEE",
    type: "reel"
  },


// {
//     id: 38,
//     title: "GO SMART | Script Video Editing",
//     url: "https://www.youtube.com/embed/KoO0KpgyZK8",
//     type: "reel"
//   },
// {
//     id: 38,
//     title: "GO SMART KW| Script Video Editing",
//     url: "https://www.youtube.com/embed/hgY8p-S3DQ",
//     type: "reel"
//   },
];

export default videosData;


